import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $el = _ref.$el,
      $f7route = _ref.$f7route;
  var rows,
      current_thoc = 0;
  var table = 'kho_thoc';

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_findAll',
              table: table,
              params: {
                where: 'deleted_at IS NULL AND id_emp IS NULL AND id_mau IS NULL'
              }
            });

          case 2:
            rs = _context.sent;
            rows = rs.rows;
            $update();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var get_current = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var rs2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Base.call({
                method: 'get_current',
                route: 'KhoThoc',
                params: {}
              });

            case 2:
              rs2 = _context2.sent;
              current_thoc = parseInt(rs2.total);
              $update();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function get_current() {
      return _ref3.apply(this, arguments);
    };
  }();

  get_current();

  var save = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var note, so_thoc, rs;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              note = $el.value.find('textarea[name="note"]').val();
              so_thoc = parseInt($el.value.find('input[name="so_thoc"]').val());

              if (!(so_thoc > current_thoc)) {
                _context3.next = 5;
                break;
              }

              $f7.dialog.alert('Quá số thóc khả dụng!');
              return _context3.abrupt("return", false);

            case 5:
              so_thoc = so_thoc * -1;
              _context3.next = 8;
              return Base.call({
                method: '_post',
                table: table,
                params: {
                  note: note,
                  so_thoc: so_thoc
                }
              });

            case 8:
              rs = _context3.sent;
              rows.push(rs.row);
              $f7.dialog.alert('Lưu lại thành công', function () {
                $f7.emit('khothoc-usedFormSubmmited');
                $el.value.find('.popup-close').click();
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function save() {
      return _ref4.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup popup-khothoc-used">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Sử dụng thóc</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".popup-khothoc-used"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">

          <div class="block text-align-center">
            <div>Số thóc khả dụng</div>
            <h3>${Utils.num2Str(current_thoc)}</h3>
          </div>

          <div class="list">
            <ul class="thoc-used-form">
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Mục đích sử dụng</div>
                  <div class="item-input-wrap">
                    <textarea name="note"></textarea>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Số thóc</div>
                  <div class="item-input-wrap">
                    <input type="number" name="so_thoc" />
                  </div>
                </div>
              </li>
              <li class="item-content">
                <div class="item-inner">
                    <a class="button button-fill" @click="${save}">Lưu lại</a>
                </div>
              </li>
            </ul>
          </div>

          <div class="card data-table margin-half">
            <table>
              <thead>
                <tr>
                  <th>Mục đích sử dụng</th>
                  <th class="numeric-cell">Số thóc</th>
                </tr>
              </thead>
              <tbody>
                ${rows && rows.map(row=>$h`
                  <tr>
                    <td>
                      <div>${row.note}</div>
                      <div>${moment(row.created_at).format('D/M/YYYY HH:mm')}</div>
                    </td>
                    <td class="numeric-cell">${row.so_thoc}</td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});